import { Effect, Layer, Schema } from "effect";
import { ResourceWorkspaceId } from "@workerstation/shared/resources/http";
import { resourceInvalid } from "@workerstation/shared/errors/resource";
import { makeResourceControlClient, ownResourceRequest } from "../resources/live.ts";
import { WorkerBindingsApi } from "./service.ts";

export const makeWorkerBindingsApi = Effect.fn("Frontend.WorkerBindingsApi.make")(function* (baseUrl: string) {
  const client = yield* makeResourceControlClient(baseUrl);
  return WorkerBindingsApi.of({
    load: Effect.fn("Frontend.WorkerBindingsApi.load")(function* (workspaceId) {
      const prepared = yield* Schema.decodeUnknownEffect(ResourceWorkspaceId)(workspaceId).pipe(Effect.mapError(() => resourceInvalid("Invalid Worker binding workerspace id.")));
      return yield* client.resources.workerBindings({ params: { workspaceId: prepared } });
    }, ownResourceRequest)
  });
});
export const WorkerBindingsApiLive = (baseUrl: string) => Layer.effect(WorkerBindingsApi, makeWorkerBindingsApi(baseUrl));
